import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsNumber, IsOptional, IsString, ValidateNested, IsDateString } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";
import { BookingServicesOrderInfo } from "./BookingServiceOrderInfo";

export class BookingServicesItems {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  contractorName!: string;
  @IsString()
  @Expose()
  recordLocator!: string;
  @IsString()
  @Expose()
  gds!: string;
  @IsDateString()
  @Expose()
  creationDate!: string;
  @IsNumber()
  @Expose()
  grandTotal!: number;
  @IsString()
  @Expose()
  currency!: string;
  @IsString()
  @Expose()
  clientSurnameName!: string;
  @IsString()
  @Expose()
  name!: string;
  @IsOptional()
  @IsString()
  @Expose()
  firstNumber!: string;
  @IsBoolean()
  @Expose()
  isVoided!: boolean;
  @IsBoolean()
  @Expose()
  isCancelled!: boolean;
  @IsBoolean()
  @Expose()
  isLocked!: boolean;
  @IsBoolean()
  @Expose()
  isClonned!: boolean;
  @IsString()
  @Expose()
  serviceTypeCode!: string;
  @IsString()
  @Expose()
  captureName!: string;
  @IsString()
  @Expose()
  @IsOptional()
  captureOrderId!: string;
  @IsBoolean()
  @Expose()
  isCaptured!: boolean;
  @IsBoolean()
  @Expose()
  canDeleteCapture!: boolean;
  @IsBoolean()
  @Expose()
  inOrder!: boolean;
  @IsString()
  @Expose()
  @IsOptional()
  comment!: string;
  @IsArray()
  @Expose()
  orderInfo!: Array<BookingServicesOrderInfo>;
  @IsBoolean()
  @Expose()
  @IsOptional()
  toExport: boolean | false = false;
}

export class BookingServicesItemsResponse extends GenericTableResponse<BookingServicesItems> {
  @Expose()
  @IsArray()
  @Type(() => BookingServicesItems)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<BookingServicesItems>;
}
